var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { FieldFilterOperator } from '@logz-pkg/enums';
import { Transform } from 'class-transformer';
export class LogsToMetricsAggregationModel {
    methods;
    histogramBuckets;
    targetField;
}
export class LogsToMetricsLabelsModel {
    key;
    value;
}
const shouldConvert = operator => operator === FieldFilterOperator.Is || operator === FieldFilterOperator.IsNot;
const mapIsOperatorValueToArray = filter => ({
    ...filter,
    value: shouldConvert(filter.operator) ? [filter.value] : filter.value,
});
const mapIsOperatorValueFromArray = filter => ({
    ...filter,
    value: shouldConvert(filter.operator) ? filter.value?.[0] : filter.value,
});
export class LogsToMetricsRuleModel {
    id;
    name;
    description;
    metricsAccountId;
    filters;
    dimensionFields;
    countLogs;
    aggregations;
    labels;
    createdAt;
    createdBy;
    updatedAt;
    updatedBy;
    enabled;
}
__decorate([
    Transform(filters => filters.map(mapIsOperatorValueFromArray), { toClassOnly: true }),
    Transform(filters => filters.map(mapIsOperatorValueToArray), { toPlainOnly: true }),
    __metadata("design:type", Array)
], LogsToMetricsRuleModel.prototype, "filters", void 0);
__decorate([
    Transform(value => value * 1000, { toClassOnly: true }),
    __metadata("design:type", Date)
], LogsToMetricsRuleModel.prototype, "createdAt", void 0);
__decorate([
    Transform(value => value * 1000, { toClassOnly: true }),
    __metadata("design:type", Date)
], LogsToMetricsRuleModel.prototype, "updatedAt", void 0);
export class LogsToMetricsRuleSearchResponseModel extends LogsToMetricsRuleModel {
    createdByName;
    updatedByName;
    metricsAccountName;
}
export class LogsToMetricsCreateRuleRequestModel {
    name;
    description;
    metricsAccountId;
    filters;
    dimensionFields;
    countLogs;
    aggregations;
    labels;
}
__decorate([
    Transform(filters => filters.map(mapIsOperatorValueToArray), { toPlainOnly: true }),
    __metadata("design:type", Array)
], LogsToMetricsCreateRuleRequestModel.prototype, "filters", void 0);
//# sourceMappingURL=model.js.map